export const formatCert = (cert: string) => {
  if (!/.*(-----BEGIN CERTIFICATE-----(?:[\s\S]*?)-----END CERTIFICATE-----)/m.test(cert)) {
    return `-----BEGIN CERTIFICATE-----${cert}-----END CERTIFICATE-----`
  }
  return cert
}
